<template>
    <div>
        <!-- <div class="name-leson margin-top-10">
            <h4>
                <strong>{{ form.name }}</strong>
            </h4>
        </div> -->
        <div class="row margin-top-10">
            <div class="col-md-12">
                <h6>Thông tin</h6>
            </div>

        </div>
        <div class="row margin-top-10">
            <div class="col-md-2">
                Bộ sách
            </div>
            <div class="col-md-4">
                <b-form-select v-model="form.bookTypeId" :options="listBookType" class="custom-select"
                    :disabled="isEdit != 1">

                </b-form-select>
            </div>
        </div>
        <div class="row margin-top-10">
            <div class="col-md-2">
                Khối lớp
            </div>
            <div class="col-md-4">
                <b-form-select v-model="form.classId" :options="listDataClass" class="custom-select"
                    :disabled="isEdit != 1">

                </b-form-select>
            </div>
        </div>
        <div class="row margin-top-10">
            <div class="col-md-2">
                Môn học
            </div>
            <div class="col-md-4">
                <b-form-select v-model="form.subjectId" :options="listDataSubject" class="custom-select"
                    :disabled="isEdit != 1">

                </b-form-select>
            </div>
        </div>
        <div class="row margin-top-10">
            <div class="col-md-2">
                Số tiết
            </div>
            <div class="col-md-4">
                <span v-if="!isEditNumberLesson">
                    {{ form.numberLesson }}
                    <img @click="handleEditNumberLesson" class="icon-edit" src="@/assets/img/edit.png"
                        v-if="isEdit == 1" />
                </span>
                <div v-else class="display-flex">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-input id="numberLesson" v-model="form.numberLesson" type="number"
                                placeholder="Nhập số tiết" autocomplete="off" class="form-control" />
                        </div>
                        <div class="col-md-6">
                            <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel"
                                @click="handleCancelEditNumberLesson">Hủy</a>
                            <a href="javascript:;" class="btn btn-agree font-size-17 btn-delete"
                                @click="handleUpdate()">Đồng ý</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="row margin-top-10">
            <div class="col-md-2">
                Công khai
            </div>
            <div class="col-md-4">
                <b-form-checkbox :disabled="isEdit != 1" v-model="form.isPublic" class="margin-left-10" name="is-public"
                    switch>
                </b-form-checkbox>
            </div>

        </div>
        <div class="row margin-top-10">
            <div class="col-md-12" v-if="!isEditDescription">
                {{ form.description }}
                <img @click="handleEditDescription" class="icon-edit" src="@/assets/img/edit.png" v-if="isEdit == 1" />
            </div>
            <div v-else class="display-flex">
                <div class="row">
                    <div class="col-md-6">
                        <b-form-textarea id="description" v-model="form.description" type="number"
                            placeholder="Nhập mô tả" autocomplete="off" class="form-control" />
                    </div>
                    <div class="col-md-6">
                        <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel"
                            @click="handleCancelEditDescription">Hủy</a>
                        <a href="javascript:;" class="btn btn-agree font-size-17 btn-delete"
                            @click="handleUpdate()">Đồng ý</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAllTypeFilter, getAllClassFilter } from './../../../_api/'
import { saveLessonClassSchool, changePublicLessonClassSchool } from './../../../_api/LessonClassSchoolServices'


export default {
    props: {
        dataElectronicLecture: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        isEdit: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            isEditDescription: false,
            isEditNumberLesson: false,
            listDataSubject: [],
            listDataClass: [],
            listBookType: [],
            form: {
                id: this.dataElectronicLecture.id,
                name: this.dataElectronicLecture.name,
                bookTypeId: this.dataElectronicLecture.bookTypeId,
                classId: this.dataElectronicLecture.classId,
                subjectId: this.dataElectronicLecture.subjectId,
                numberLesson: this.dataElectronicLecture.numberLesson,
                description: this.dataElectronicLecture.description,
                isPublic: this.dataElectronicLecture.isPublic,
                type: this.dataElectronicLecture.type,
            }
        }
    },
    watch: {
        'form.bookTypeId': 'handleUpdate',
        'form.classId': 'handleUpdate',
        'form.subjectId': 'handleUpdate',
        'form.isPublic': 'onChangePublic',
    },
    mounted() {
        this.GetAllClass()
        this.getTypesFilter()

        console.log(this.form.bookTypeId)
        // this.form = {
        //     id: this.dataElectronicLecture.id,
        //     name: this.dataElectronicLecture.name,
        //     bookTypeId: this.dataElectronicLecture.bookTypeId,
        //     classId: this.dataElectronicLecture.classId,
        //     subjectId: this.dataElectronicLecture.subjectId,
        //     numberLesson: this.dataElectronicLecture.numberLesson,
        //     description: this.dataElectronicLecture.description,
        //     isPublic:this.dataElectronicLecture.isPublic,
        //     type: this.dataElectronicLecture.type,
        // }
    },
    methods: {
        onChangePublic(e) {

            let param = {
                id: this.form.id,
                isPublic: this.form.isPublic
            }
            this.handleChangePublic(param)
        },
        handleChangePublic(param) {
            changePublicLessonClassSchool(param).then((res) => {
                if (res && res.data && !res.errors) {
                    this.$toast.success('Thay đổi chế độ thành công')
                }
            })
        },
        handleEditDescription() {
            this.isEditDescription = true
        },
        handleCancelEditDescription() {
            this.isEditDescription = false
        },
        handleUpdate() {
            let self = this
            saveLessonClassSchool(this.form).then(res => {
                if (res && res.data && !res.errors) {
                    self.$toast.success('Cập nhật thông tin thành công')
                    self.getDetailLessonClassSchool()
                    this.handleCancelEditNumberLesson()
                    this.handleCancelEditDescription()
                }
            })
        },
        getDetailLessonClassSchool() {
            // let self = this
            // getDetail(this.dataElectronicLecture.id).then(res => {
            //     if (res && res.data && !res.errors) {
            //         self.form = {
            //             id: res.data.id,
            //             name: res.data.name,
            //             bookTypeId: res.data.bookTypeId,
            //             classId: res.data.classId,
            //             subjectId: res.data.subjectId,
            //             numberLesson: res.data.numberLesson,
            //             description: res.data.description,
            //             isPublic: res.data.isPublic,
            //             type: res.data.type,
            //         }
            //     }
            // })
            this.$emit('getDetailLessonClassSchool')
        },
        handleCancelEditNumberLesson() {
            this.isEditNumberLesson = false
        },
        handleEditNumberLesson() {
            this.isEditNumberLesson = true
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = []
            self.listBookType = []
            getAllTypeFilter({ classId: this.form.classId }).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                    for (let i = 0; i < res.data.ltsBookType.length; i++) {
                        const item = res.data.ltsBookType[i];
                        self.listBookType.push({ value: item.bookGroupId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            self.listDataClass = []
            getAllClassFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-edit {
    width: 15px;
    cursor: pointer;
}

.btn-agree {
    margin-left: 10px;
    background: #0f3dba;
    color: white;
    line-height: 19px;
}

.margin-top-10 {
    margin-top: 20px;
}
</style>